import React from 'react';
import UserPlansContainer from './UserPlansContainer';

const UserPlansView = () => {
  return <UserPlansContainer></UserPlansContainer>;
};

export default UserPlansView;
